import { isFreelancerWorker } from '../../../utils/workerType';
const FIXED_COMPANY_ORDER = new Map([['PINE', 0], ['SALES', 1], ['DOT', 2], ['LNJ', 3]]);

// hq {code, name}: 보는 사람 테넌트의 대표 회사. 그 회사 직원 묶음의 머리글을 회사 코드('PINE'·'LINK') 대신
//   회사 이름('파인그룹'·'미팅링크')으로 — 같은 화면 왼쪽(업무·기능 목록, itemGrouping)과 맞춘다(2026-09-24). 없으면 종전.
export function getEmployeeCompanyGroup(emp, hq = null) {
  const workerType = String(emp.workerType || '').trim().toLowerCase();
  if (isFreelancerWorker(workerType)) {
    // 3.3% 인원 묶음 — 머리글만 '3.3%'(2026-11-03 합치기-2, 예전 'sales'). 묶음 열쇠(key·code)는 그대로.
    return {
      key: 'company:SALES',
      code: 'SALES',
      label: '3.3%',
      order: FIXED_COMPANY_ORDER.get('SALES'),
    };
  }

  const code = String(emp.companyCode || 'PINE').trim().toUpperCase() || 'PINE';
  // 본사(이 사이트 주인 회사, hq.code) 묶음이 맨 위 — 'PINE' 글자로만 정하면 미팅링크 본사(LINK) 묶음이 'sales' 아래·다른 회사와 섞였다(2026-10-30)
  const isHq = Boolean(hq?.code) && code === String(hq.code).toUpperCase();
  const order = isHq ? 0 : (FIXED_COMPANY_ORDER.has(code) ? FIXED_COMPANY_ORDER.get(code) : 100);
  return {
    key: `company:${code}`,
    code,
    label: (hq?.name && hq.code && code === String(hq.code).toUpperCase()) ? hq.name : (emp.companyName || code),
    order,
  };
}

export function compareEmployeeNo(left, right) {
  const a = String(left || '').trim();
  const b = String(right || '').trim();
  if (a && b) return a.localeCompare(b, 'ko-KR', { numeric: true, sensitivity: 'base' });
  if (a) return -1;
  if (b) return 1;
  return 0;
}

export function compareGroupedEmployee(a, b) {
  return a.companyGroup.order - b.companyGroup.order
    || String(a.companyGroup.label || '').localeCompare(String(b.companyGroup.label || ''), 'ko-KR')
    || compareEmployeeNo(a.employeeNo, b.employeeNo)
    || String(a.name || '').localeCompare(String(b.name || ''), 'ko-KR')
    || String(a.loginId || '').localeCompare(String(b.loginId || ''), 'ko-KR', { numeric: true });
}

export function groupEmployees(employees) {
  const groups = new Map();
  for (const emp of employees) {
    const key = emp.companyGroup.key;
    if (!groups.has(key)) groups.set(key, { ...emp.companyGroup, items: [] });
    groups.get(key).items.push(emp);
  }
  return Array.from(groups.values());
}
